'use strict';

const _ = require('underscore');
const Backbone = require('backbone/backbone');
const Constants = require('constants/Constants');
const Events = require('constants/Events');
require('./IndexHeroCard.less');

//a 3D rendering library
const THREE = require('three');

//a library to load 3ds models into three js
const TDSLoader = require('three-3dsloader');

const Selectors = {
    el: '.IndexHeroCard',
    canvasWrapper: '.IndexHeroCard-canvas',
    sequence: '.IndexHero-sequence',
    tailored: '.IndexTailored',
    heroTitleWrapper: '.IndexHero-titleWrapper',
    featuresSequence: '.IndexFeatures-sequences-wrapper',
    purpleCard: '.IndexPurpleCard-card'
};

const Assets = {
    folderAttr: 'data-assets-folder',

    card3d: 'card-intro.3ds',
    glass3d: 'intro-glass.3ds',

    textureCard: 'Card_Color.jpg',
    textureChip: 'Chip_Color.jpg',
    textureReflections: 'Card_Reflections.png',
    textureShade: 'Card_Shade.png',

    textureGlassLeft: 'Glass_Left_Color.jpg',
    textureGlassRight: 'Glass_Right_Color.jpg',

    textureGlassLeftRefraction: 'Glass_Left_Refraction.png',
    textureGlassRightRefraction: 'Glass_Right_Refraction.png',

    textureCodeLeft: 'Code_Left.png',
    textureCodeRight: 'Code_Right.png'
};

const BindFunctions = [
    'attachEvents',
    'init3DScene',
    'initTextureLoader',
    'getTextures',
    'onResize',
    'fadeInCanvas',
    'onLoadCanvas',
    'onScroll'
];

const cameraFarPlane = 1000;
const cameraFOV = 23.121;
const cameraNearPlane = 0.1;
const cameraPositionZ = 42.96912326341566;
const videoAspect = 924 / 800; // video sequence h / w
const baseVideoWidth = 428.57142857142856; //not 431, but real 428.571... based on video aspect
const baseCanvasHeight = 960;
const videoSpherePercentagePosX = 274 / 800; //percentage position of green left sphere center inside video sequence
const videoSpherePercentagePosY = 412 / 924;
const countModels = 2; // count of.settings 3ds
const controlPoints = [0, /*38, 51,*/ 80, 100]; //do not change first and the last one
const finishCornerPosition = [-1.35204347503218, 5.5646033838423685, 0.116097874988915]; //reference point (bottom-right card corner) to align 3d card to 2d purplecard
const settings = {
    card: {
        position: [1.080, 1.982, 0],
        rotation: [-1.528157646884768, 0.06139539100521132, -0.4622051287427435]
    },
    glasses: {
        position: [1.080, 1.982, 0],
        rotation: [-1.528157646884768, 0.06139539100521132, -0.4622051287427435]
    },
    pointLight: {
        position: [-2.403, 7.341, 1.487]
    },
    textures: [{
        offset: [0, 0],
        scale: [1, 1],
        rotation: [0]
    }, {
        offset: [0, 0],
        scale: [1, 1],
        rotation: [0]
    }, {
        offset: [0, 0],
        scale: [1, 1],
        rotation: [0]
    }, {
        offset: [0, 0],
        scale: [1, 1],
        rotation: [0]
    }, {
        offset: [100 / 2999, -5 / 2999],
        scale: [1819 / 2999, 1],
        rotation: [-1 / 360 * Math.PI]
    }, {
        offset: [0, 0],
        scale: [1, 1],
        rotation: [0]
    }, {
        offset: [-0.047, 0],
        scale: [1, 1024 / 1675],
        rotation: [0]
    }, {
        offset: [-0.03, 0],
        scale: [1, 1024 / 1788],
        rotation: [0]
    }, {
        offset: [0, (6 * 30 * 512 / 600) / 512],
        scale: [1, (512 - 6 * 30 * 512 / 600) / 512],
        rotation: [0]
    }, {
        offset: [0, (7 * 30 * 512 / 600) / 512],
        scale: [1, (512 - 7 * 30 * 512 / 600) / 512],
        rotation: [0]
    }]
};

module.exports = Backbone.View.extend({

    el: Selectors.el,

    initialize: function (options = {}) {
        _.bindAll(this, BindFunctions);

        this.options = options;

        app.vent.on(Events.home.hero.sequenceStarted, this.initTextureLoader);
        // app.vent.on(Events.home.hero.sequenceEnded, this.initTextureLoader);

        this.attachEvents();
    },

    initTextureLoader: function () {
        this.$canvasWrapper = this.$(Selectors.canvasWrapper);
        this.$sequence = $(Selectors.sequence);

        this.folder = this.$el.attr(Assets.folderAttr);

        if (app.settings.isWebp) {
            Assets.textureCard = 'Card_Color.webp';
            Assets.textureReflections = 'Card_Reflections.webp';
            Assets.textureShade = 'Card_Shade.webp';

            Assets.textureChip = 'Chip_Color.webp';

            Assets.textureGlassLeft = 'Glass_Left_Color.webp';
            Assets.textureGlassRight = 'Glass_Right_Color.webp';
            Assets.textureGlassLeftRefraction = 'Glass_Left_Refraction.webp';
            Assets.textureGlassRightRefraction = 'Glass_Right_Refraction.webp';

            Assets.textureCodeLeft = 'Code_Left.webp';
            Assets.textureCodeRight = 'Code_Right.webp';
        }

        const texturesSRC = [
            Assets.textureCard,
            Assets.textureChip,
            Assets.textureGlassLeft,
            Assets.textureGlassRight,
            Assets.textureReflections,
            Assets.textureShade,
            Assets.textureGlassLeftRefraction,
            Assets.textureGlassRightRefraction,
            Assets.textureCodeLeft,
            Assets.textureCodeRight
        ].map(texture => this.folder + texture);

        Promise.all(this.getTextures(texturesSRC))
            .then((textures) => {
                return new Promise((resolve) => {
                    this.init3DScene(textures, resolve);
                });
            })
            .then(this.onResize)
            .then(this.onLoadCanvas)
            .catch(err => console.error(err));
    },

    getTextures: function (texturesSources) {
        const loader = new THREE.TextureLoader();

        return texturesSources.map(textureSource => {
            return new Promise((resolve, reject) => {
                loader.load(
                    textureSource,
                    texture => {
                        resolve(texture);
                    },
                    undefined,
                    err => reject(err)
                );
            });
        });
    },

    init3DScene: function (textures, resolve) {
        let modelsLoadedCount = 0;
        this.textures = textures || [];

        this.textures.forEach(function (item, index) {
            item.offset = new THREE.Vector2(...settings.textures[index].offset);
            item.repeat.set(...settings.textures[index].scale);
            item.rotation = settings.textures[index].rotation[0];
        });

        //selecting a renderer to use
        this.renderer = new THREE.WebGLRenderer({
            antialias: true,
            alpha: true
        });

        // this.renderer.outputEncoding = THREE.sRGBEncoding;
        this.renderer.physicallyBasedShading = true;
        this.renderer.setPixelRatio(window.devicePixelRatio || 1); //set retina for uses devices
        this.$canvasWrapper.append(this.renderer.domElement);

        //initialize scene and camera
        this.scene = new THREE.Scene();
        this.camera = new THREE.PerspectiveCamera(cameraFOV, 1, cameraNearPlane, cameraFarPlane);
        this.camera.position.z = cameraPositionZ;
        this.camera.lookAt(0, 0, 0);
        this.scene.add(this.camera);


        this.glasses = new THREE.Group();
        this.scene.add(this.glasses);

        const materialSphere = new THREE.MeshBasicMaterial({
            color: 0x0be0d8
        });

        const geoSphereLeft = new THREE.SphereGeometry(0.083, 8, 8);
        const meshSphereLeft = new THREE.Mesh(geoSphereLeft, materialSphere);
        meshSphereLeft.position.set(-0.320, 2.352, 0.390);
        this.glasses.add(meshSphereLeft);

        const geoSphereRight = new THREE.SphereGeometry(0.083, 8, 8);
        const meshSphereRight = new THREE.Mesh(geoSphereRight, materialSphere);
        meshSphereRight.position.set(1.716, 0.168, 1.101);
        this.glasses.add(meshSphereRight);

        this.referencePoint = [
            meshSphereLeft.position.x,
            meshSphereLeft.position.y,
            meshSphereLeft.position.z
        ];

        const curvePath = new THREE.CubicBezierCurve3(
            new THREE.Vector3(-0.320, 2.356, 0.360),
            new THREE.Vector3(0.88, 2.32, 0.4),
            new THREE.Vector3(0.53, 0.215, 1.060),
            new THREE.Vector3(1.710, 0.180, 1.1)
        );

        const materialCurve = new THREE.MeshBasicMaterial({
            color: 0x16bcdc
        });

        const geometryCurve = new THREE.TubeGeometry(curvePath, 30, 0.014, 4, false);
        const curve = new THREE.Mesh(geometryCurve, materialCurve);
        this.glasses.add(curve);


        const ambientLight = new THREE.AmbientLight(0xffffff, 1);
        this.scene.add(ambientLight);

        this.pointLight = new THREE.PointLight(0xffffff, 0.5);

        this.pointLight.position.set(...settings.pointLight.position);

        this.scene.add(this.pointLight);


        (new TDSLoader()).load(this.folder + Assets.card3d, function (object) {
            // material without shader, material
            const materialCard = new THREE.MeshBasicMaterial({
                color: 0xffffff,
                map: textures[0],
                transparent: true
            });

            const materialContacts = new THREE.MeshPhongMaterial({
                color: 0xc0c1f6,
                map: textures[1],
                shininess: 18,
                specular: 0xc0c1f6,
                transparent: true
            });

            object.children[0].material = materialCard;
            object.children[1].material = materialContacts;
            object.remove(object.children[2]);

            object.children[1].position.y -= 0.02;

            object.position.set(...settings.card.position);
            object.rotation.set(...settings.card.rotation);

            const geometry = object.children[0].geometry; // substitute the path to your geometry
            geometry.computeBoundingBox(); // otherwise geometry.boundingBox will be undefined
            const boundingBox = geometry.boundingBox;



            // var cardRightBottomCorner = new THREE.SphereGeometry(0.01, 4, 4);
            // const cardLeftCornerMaterial = new THREE.MeshBasicMaterial({
            //     color: 0xffffff,
            //     opacity: 0
            // });

            // this.cardRightBottomCorner = new THREE.Mesh(cardRightBottomCorner, cardLeftCornerMaterial);
            // this.cardRightBottomCorner.position.set(boundingBox.max.x, boundingBox.min.y, boundingBox.min.z);
            // object.add(this.cardRightBottomCorner);


            const planeBorderRadius = 0.35;
            const planeGeometry = app.utils.makeRoundedCornerPlane(
                geometry.boundingBox.max.x - geometry.boundingBox.min.x - planeBorderRadius * 2,
                geometry.boundingBox.max.z - geometry.boundingBox.min.z - planeBorderRadius * 2,
                planeBorderRadius
            );


            const reflectionsMaterial = new THREE.MeshBasicMaterial({
                color: 0xffffff,
                map: textures[4],
                transparent: true
            });

            this.reflectionsMaterial = reflectionsMaterial;

            const planeReflections = new THREE.Mesh(planeGeometry, reflectionsMaterial);
            planeReflections.position.y = boundingBox.min.y - 0.01;
            planeReflections.rotation.x = Math.PI / 2;
            object.add(planeReflections);


            const shadeMaterial = new THREE.MeshBasicMaterial({
                color: 0xffffff,
                map: textures[5],
                transparent: true
            });

            this.shadeMaterial = shadeMaterial;

            const planeShade = new THREE.Mesh(planeGeometry, shadeMaterial);
            planeShade.position.y = boundingBox.min.y - 0.005;
            planeShade.rotation.x = Math.PI / 2;
            object.add(planeShade);

            object.scale.x = 1.0052191659488976;
            object.scale.z = 1.0179317658021172;

            this.card = object;
            this.scene.add(object);

            modelsLoadedCount++;

            (modelsLoadedCount === countModels) && resolve();
        }.bind(this));


        (new TDSLoader()).load(this.folder + Assets.glass3d, function (object) {
            const materialGlassLeft = new THREE.MeshBasicMaterial({
                color: 0xffffff,
                map: textures[2]
            });

            const materialGlassRight = new THREE.MeshBasicMaterial({
                color: 0xffffff,
                map: textures[3]
            });

            object.children[1].material = materialGlassLeft;
            object.children[2].material = materialGlassRight;

            object.position.set(...settings.glasses.position);
            object.rotation.set(...settings.glasses.rotation);

            object.children[1].position.x = -2.60;
            object.children[1].position.y = 0.48;
            object.children[1].position.z = -0.685;

            object.children[1].scale.x = 0.99;
            object.children[1].scale.z = 1.005;
            object.children[1].scale.y = 1.4;

            object.children[2].position.x = 2.72;
            object.children[2].position.y = -1.802;
            object.children[2].position.z = -0.72;

            object.children[2].scale.x = 1.01;
            object.children[2].scale.z = 1.02;
            object.children[2].scale.y = 1.1;


            const geometryLeft = object.children[1].geometry; // substitute the path to your geometry
            geometryLeft.computeBoundingBox(); // otherwise geometry.boundingBox will be undefined
            const boundingBoxLeft = geometryLeft.boundingBox;

            const geometryRight = object.children[2].geometry; // substitute the path to your geometry
            geometryRight.computeBoundingBox(); // otherwise geometry.boundingBox will be undefined
            const boundingBoxRight = geometryRight.boundingBox;

            const padding = 0.05;

            const planeBorderRadius = 0.18;
            const planeGeometryLeft = app.utils.makeRoundedCornerPlane(
                geometryLeft.boundingBox.max.x - geometryLeft.boundingBox.min.x - planeBorderRadius * 2 - padding,
                geometryLeft.boundingBox.max.z - geometryLeft.boundingBox.min.z - planeBorderRadius * 2 - padding,
                planeBorderRadius
            );

            const refractionsMaterialLeft = new THREE.MeshBasicMaterial({
                color: 0xffffff,
                map: textures[6],
                transparent: true
            });

            const planeLeftRefractions = new THREE.Mesh(planeGeometryLeft, refractionsMaterialLeft);
            planeLeftRefractions.position.x = 0.04;
            planeLeftRefractions.position.y = boundingBoxLeft.min.y - 0.01;
            planeLeftRefractions.position.z = 0.995;

            planeLeftRefractions.rotation.x = Math.PI / 2;
            object.children[1].add(planeLeftRefractions);


            const codeLeftGeometry = new THREE.PlaneGeometry(
                geometryLeft.boundingBox.max.x - geometryLeft.boundingBox.min.x + 0.01,
                geometryLeft.boundingBox.max.z - geometryLeft.boundingBox.min.z - 0.4,
                1,
                1
            );
            textures[8].minFilter = THREE.NearestMipmapLinearFilter;
            textures[8].anisotropy = 8;
            const codeLeftMaterial = new THREE.MeshBasicMaterial({
                color: 0xffffff,
                map: textures[8],
                transparent: true
            });

            const codeLeft = new THREE.Mesh(codeLeftGeometry, codeLeftMaterial);
            codeLeft.position.x = -0.025;
            codeLeft.position.y = boundingBoxLeft.min.y - 0.04;
            codeLeft.position.z = 1.02;
            codeLeft.rotation.x = Math.PI / 2;
            object.children[1].add(codeLeft);



            const planeGeometryRight = app.utils.makeRoundedCornerPlane(
                geometryRight.boundingBox.max.x - geometryRight.boundingBox.min.x - planeBorderRadius * 2 - padding,
                geometryRight.boundingBox.max.z - geometryRight.boundingBox.min.z - planeBorderRadius * 2 - padding,
                planeBorderRadius
            );

            const refractionsMaterialRight = new THREE.MeshBasicMaterial({
                color: 0xffffff,
                map: textures[7],
                transparent: true
            });

            const planeRightRefractions = new THREE.Mesh(planeGeometryRight, refractionsMaterialRight);
            planeRightRefractions.position.y = boundingBoxRight.min.y - 0.01;
            planeRightRefractions.rotation.x = Math.PI / 2;
            planeRightRefractions.position.z = -1.01;
            object.children[2].add(planeRightRefractions);


            const codeRightGeometry = new THREE.PlaneGeometry(
                geometryRight.boundingBox.max.x - geometryRight.boundingBox.min.x + 0.01,
                geometryRight.boundingBox.max.z - geometryRight.boundingBox.min.z - 0.55,
                1,
                1
            );
            textures[9].minFilter = THREE.NearestMipmapLinearFilter;
            textures[9].anisotropy = 8;
            const codeRightMaterial = new THREE.MeshBasicMaterial({
                color: 0xffffff,
                map: textures[9],
                transparent: true
            });

            const codeRight = new THREE.Mesh(codeRightGeometry, codeRightMaterial);
            codeRight.position.x = 0.01;
            codeRight.position.y = boundingBoxRight.min.y - 0.04;
            codeRight.position.z = -1.025;
            codeRight.rotation.x = Math.PI / 2;
            object.children[2].add(codeRight);


            this.glasses.add(object);

            modelsLoadedCount++;

            (modelsLoadedCount === countModels) && resolve();
        }.bind(this));

        app.vent.on(Events.common.resizeEnded, this.onResize);
    },

    attachEvents: function () {
        // app.vent.on(Events.home.hero.sequenceEnded, this.fadeInCanvas);
        app.vent.on(Events.home.hero.sequenceHidded, this.fadeInCanvas);
    },

    onResize: function () {
        const purpleCard = $(Selectors.purpleCard)[0];
        const purpleCardStyle = purpleCard.style.cssText;

        purpleCard.style.cssText = 'display: block';
        const purpleCardBB = $(Selectors.purpleCard)[0].getBoundingClientRect();
        purpleCard.style.cssText = purpleCardStyle;

        this.isMobile = window.matchMedia('(max-width: 767px)').matches;

        this.cpPositions = {
            subtitle: $(Selectors.heroTitleWrapper).offset().top + $(Selectors.heroTitleWrapper).height() / 2,
            features: $(Selectors.featuresSequence).offset().top - 100,
            bottom: $(Selectors.tailored).offset().top + 160,
            purpleCardLeftTopX: purpleCardBB.left + purpleCardBB.width  * 446 / 634
        };

        if (this.isMobile) {
            const featuresSequenceH = $(Selectors.featuresSequence).height();
            this.cpPositions.scrollRange = this.cpPositions.features + 4 * featuresSequenceH / 5 - window.innerHeight;
            this.yShiftPoints = [
                [controlPoints[0], [190]],
                [controlPoints[2], [
                    this.cpPositions.features +
                    featuresSequenceH / 3 -
                    controlPoints[2] * this.cpPositions.scrollRange / 100
                ]]
            ];
        } else {
            this.cpPositions.scrollRange = $(Selectors.tailored).offset().top - window.innerHeight;
            this.yShiftPoints = [
                [controlPoints[0], [this.cpPositions.subtitle - controlPoints[0] * this.cpPositions.scrollRange / 100]],
                [controlPoints[1], [this.cpPositions.features - controlPoints[1] * this.cpPositions.scrollRange / 100]],
                [controlPoints[2], [this.cpPositions.bottom - controlPoints[2] * this.cpPositions.scrollRange / 100]]
            ];
        }

        const sequenceBB = this.$sequence[0].getBoundingClientRect();
        const sequenceWidth = sequenceBB.width;
        const sequenceHeight = sequenceBB.height;
        const sequenceLeft = sequenceBB.left;
        const sequenceTop = sequenceBB.top + window.pageYOffset;

        const canvasBB = this.$canvasWrapper[0].getBoundingClientRect();
        this.width = canvasBB.width;
        this.height = canvasBB.height;
        const canvasLeft = canvasBB.left;
        const canvasTop = canvasBB.top;

        let realVideoWidth = sequenceWidth;
        let realVideoHeight = sequenceWidth * videoAspect;
        let videoTop = sequenceTop + (sequenceHeight - realVideoHeight) / 2;
        let videoLeft = sequenceLeft;

        if (sequenceHeight / sequenceWidth < videoAspect) {
            realVideoWidth = sequenceHeight / videoAspect;
            realVideoHeight = sequenceHeight;
            videoTop = sequenceTop;
            videoLeft = sequenceLeft + (sequenceWidth - realVideoWidth) / 2;
        }

        const tanFOV = Math.tan(cameraFOV * Math.PI / 360);
        const heightMultiplier = this.height / baseCanvasHeight;
        const widthMultiplier = baseVideoWidth / realVideoWidth;

        this.camera.fov = (360 / Math.PI) * Math.atan(tanFOV * heightMultiplier * widthMultiplier);

        this.camera.clearViewOffset();
        this.camera.aspect = this.width / this.height;
        this.camera.updateProjectionMatrix();
        this.renderer.setSize(this.width, this.height);
        this.renderer.render(this.scene, this.camera);

        //get projected 2d point of left green sphere center on the canvas
        //relative to page top left corner
        const reference2DPosition = this.get3dTo2dProjection(new THREE.Vector3(...this.referencePoint));
        const canvasSphereX = canvasLeft + reference2DPosition.x;
        const canvasSphereY = canvasTop + reference2DPosition.y;

        //get 2d point of left green sphere center on the video
        //relative to page top left corner
        const videoSphereX = videoLeft + realVideoWidth * videoSpherePercentagePosX;
        const videoSphereY = videoTop + realVideoHeight * videoSpherePercentagePosY;

        this.viewOffset = [canvasSphereX - videoSphereX, canvasSphereY - videoSphereY];

        if (!this.isMobile) {
            // let cardRightBottomCornerPos = new THREE.Vector3();
            // this.cardRightBottomCorner.getWorldPosition(cardRightBottomCornerPos);
            // console.log(cardRightBottomCornerPos);
            //const finishCornerPosition = [-1.49204347503218, 5.5646033838423685, 0.116097874988915];
            // let cardRightBottomCornerPos2d = this.get3dTo2dProjection(cardRightBottomCornerPos);
            let cardRightBottomCornerPos2d = this.get3dTo2dProjection(new THREE.Vector3(...finishCornerPosition));

            this.xShiftPoints = [
                [controlPoints[0], [0]],
                [controlPoints[1], [0]],
                [controlPoints[2], [
                    canvasLeft + cardRightBottomCornerPos2d.x - this.cpPositions.purpleCardLeftTopX - this.viewOffset[0]
                ]]
            ];
        }

        this.createAnimations();
        this.prevProgress = null;
        this.onScroll(window.pageYOffset);
    },

    get3dTo2dProjection: function (vector3d) {
        const vector = vector3d.project(this.camera);

        vector.x = (vector.x + 1) / 2 * this.width;
        vector.y = -(vector.y - 1) / 2 * this.height;

        return vector;
    },


    fadeInCanvas: function () {
        if (this.$canvasWrapper.hasClass(Constants.cssClasses.isHide)) {
            this.$canvasWrapper.removeClass(Constants.cssClasses.isHide);
            // this.onResize();
        }
    },


    createAnimations: function () {
        this.animations = [{
            obj: this.glasses,
            tp: 'position',
            cp: [
                [controlPoints[0], [0, 0, 0]],
                [15, [0, 10, 0]],
                [controlPoints[2], [0, 10, 0]]
            ]
        }, {
            obj: this.textures[4], //card reflections
            tp: 'tex_offset',
            cp: [
                [controlPoints[0], [...settings.textures[4].offset]],
                [14, [0, -1]],
                [controlPoints[2], [0, -1]]
            ]
        }, {
            obj: this.textures[4], //card reflections
            tp: 'tex_rotation',
            cp: [
                [controlPoints[0], [...settings.textures[4].rotation]],
                [14, [4 / 360 * Math.PI]],
                [controlPoints[2], [4 / 360 * Math.PI]]
            ]
        }, {
            obj: this.textures[6], //left refraction
            tp: 'tex_offset',
            cp: [
                [controlPoints[0], [...settings.textures[6].offset]],
                [4, [...settings.textures[6].offset]],
                [9, [0, 1]],
                [controlPoints[2], [0, 1]]
            ]
        }, {
            obj: this.textures[7], //right refraction
            tp: 'tex_offset',
            cp: [
                [controlPoints[0], [...settings.textures[7].offset]],
                [5, [-0.15, 0]],
                [11.5, [-0.3, 1]],
                [controlPoints[2], [-0.3, 1]]
            ]
        }, {
            obj: this.textures[7], //card reflections
            tp: 'tex_rotation',
            cp: [
                [controlPoints[0], [...settings.textures[7].rotation]],
                [5, [...settings.textures[7].rotation]],
                [11.5, [15 / 360 * Math.PI]],
                [controlPoints[2], [15 / 360 * Math.PI]]
            ]
        }, {
            obj: this.textures[8], //left code
            tp: 'tex_offset',
            cp: [
                [controlPoints[0], [...settings.textures[8].offset]],

                [1.99, [...settings.textures[8].offset]],
                [2.0, [0, (5 * 30 * 512 / 600) / 512]],

                [5.49, [0, (5 * 30 * 512 / 600) / 512]],
                [5.5, [0, (4 * 30 * 512 / 600) / 512]],

                [controlPoints[2], [0, (2 * 30 * 512 / 600) / 512]]
            ]
        },  {
            obj: this.textures[9], //right code
            tp: 'tex_offset',
            cp: [
                [controlPoints[0], [...settings.textures[9].offset]],

                [2.49, [...settings.textures[9].offset]],
                [2.5, [0, (6 * 30 * 512 / 600) / 512]],

                [5.99, [0, (6 * 30 * 512 / 600) / 512]],
                [6.0, [0, (5 * 30 * 512 / 600) / 512]],

                [8.49, [0, (5 * 30 * 512 / 600) / 512]],
                [8.5, [0, (4 * 30 * 512 / 600) / 512]],

                [controlPoints[2], [0, (7 * 30 * 512 / 600) / 512]]
            ]
        }, {
            obj: this.reflectionsMaterial,
            tp: 'mat_opacity',
            cp: [
                [controlPoints[0], [1]],
                [7, [1]],
                [15, [0]],
                [controlPoints[2], [0]]
            ]
        }, {
            obj: this.shadeMaterial,
            tp: 'mat_opacity',
            cp: [
                [controlPoints[0], [1]],
                [7, [1]],
                [17, [0]],
                [controlPoints[2], [0]]
            ]
        }, {
            obj: this.pointLight,
            tp: 'position',
            cp: [
                [controlPoints[0], [...settings.pointLight.position]],
                [7, [0.578, 7.341, 1.487]],
                [20, [-2.779, 7.341, 3.681]],
                [controlPoints[2], [-2.779, 7.341, 3.681]]
            ]
        }];

        if (!this.isMobile) {
            this.animations.push({
                obj: this.card,
                tp: 'position',
                cp: [
                    [controlPoints[0], [...settings.card.position]],
                    [controlPoints[1], [5.880, 1.982, -48]],
                    [controlPoints[2], [-2.950, 1.982, 3.5]]
                ]
            });

            this.animations.push({
                obj: this.card,
                tp: 'rotation',
                cp: [
                    [controlPoints[0], [...settings.card.rotation]],
                    [controlPoints[1], [-180 * Math.PI / 360, -320 * Math.PI / 360, 0]],
                    [controlPoints[2], [-2.3, -2.298, 0.072]]
                ]
            });

            this.animations.push({
                obj: this.card.children[0].material,
                tp: 'mat_opacity',
                cp: [
                    [controlPoints[0], [1]],
                    [controlPoints[2], [1]]
                ]
            });

            this.animations.push({
                obj: this.card.children[1].material,
                tp: 'mat_opacity',
                cp: [
                    [controlPoints[0], [1]],
                    [controlPoints[2], [1]]
                ]
            });
        } else {
            this.animations.push({
                obj: this.card,
                tp: 'position',
                cp: [
                    [controlPoints[0], [...settings.card.position]],
                    [controlPoints[2], [2.880, 1.982, -25]]
                ]
            });

            this.animations.push({
                obj: this.card,
                tp: 'rotation',
                cp: [
                    [controlPoints[0], [...settings.card.rotation]],
                    [controlPoints[2], [-180 * Math.PI / 360, -35 * Math.PI / 360, 0]]
                ]
            });

            this.animations.push({
                obj: this.card.children[0].material,
                tp: 'mat_opacity',
                cp: [
                    [controlPoints[0], [1]],
                    [9, [1]],
                    [12, [0.1]],
                    [95, [0.1]],
                    [controlPoints[2], [0]]
                ]
            });

            this.animations.push({
                obj: this.card.children[1].material,
                tp: 'mat_opacity',
                cp: [
                    [controlPoints[0], [1]],
                    [9, [1]],
                    [12, [0.1]],
                    [95, [0.1]],
                    [controlPoints[2], [0]]
                ]
            });
        }
    },

    onLoadCanvas: function () {
        app.vent.on(Events.common.scroll, this.onScroll);
        this.onScroll(window.pageYOffset);
        this.fadeInCanvas();

        app.vent.trigger(Events.home.hero.cardLoaded);
    },


    onScroll: function (scrollTop) {
        const progressRaw = 100 * scrollTop / this.cpPositions.scrollRange;
        const progress = Math.max(Math.min(progressRaw, 100), 0);

        if (progressRaw > (this.isMobile ? 100 : 110)) {
            if (this.canvasVisible) {
                this.$canvasWrapper.css('visibility', 'hidden');
                this.canvasVisible = false;
                // if (this.isMobile) {
                //     this.$canvasWrapper.css('transition', '0.25s opacity');
                // }
            }
        } else {
            if (!this.canvasVisible) {
                this.$canvasWrapper.css('visibility', 'visible');
                this.canvasVisible = true;
            }
        }

        if (progress === this.prevProgress) {
            return;
        }

        this.prevProgress = progress;

        const getInterpolated = (cp, progress) => {
            const len = cp.length;
            let prevPercentage = 0;

            for (let i = 0; i < len; i++) {
                let percentage = cp[i][0];
                let points = cp[i][1];

                if (percentage === progress) {
                    return points;
                }

                if (percentage > progress) {
                    const localProgress = (progress - prevPercentage) / (percentage - prevPercentage);
                    const res = [];

                    for (let j = 0; j < points.length; j++) {
                        res[j] = app.utils.easingFunctions(cp[i - 1][1][j], points[j], localProgress, 'easeInOutSine');
                    }

                    return res;
                }

                prevPercentage = percentage;
            }
        };

        let yShift;
        let xShift;

        if (!this.isMobile) {
            yShift = getInterpolated(this.yShiftPoints, progress)[0] - this.cpPositions.subtitle;
            xShift = getInterpolated(this.xShiftPoints, progress)[0];
        } else {
            yShift = getInterpolated(this.yShiftPoints, progress)[0] - this.yShiftPoints[0][1][0];
            xShift = 0;
        }

        this.glasses.visible = progress < 15;

        this.animations.forEach(function (item) {
            const res = getInterpolated(item.cp, progress);

            if (item.tp === 'position') {
                item.obj.position.set(...res);
            }
            if (item.tp === 'rotation') {
                item.obj.rotation.set(...res);
            }
            if (item.tp === 'tex_offset') {
                item.obj.offset = new THREE.Vector2(...res);
            }
            if (item.tp === 'tex_rotation') {
                item.obj.rotation = res[0];
            }
            if (item.tp === 'mat_opacity') {
                item.obj.opacity = res[0];
            }
        });

        this.camera.setViewOffset(
            this.width,
            this.height,
            this.viewOffset[0] + xShift,
            this.viewOffset[1] - yShift,
            this.width,
            this.height
        );

        this.renderer.render(this.scene, this.camera);
    }
});
